import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_REV_SHARE_PERIODS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/rev-share-periods',
        iconClass: 'fas fa-chart-pie',
        name: 'Rev Shares',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.RevShares',
        order: 5
      },
    ]);
  };
}
